import { useCallback } from 'react'
import { ModalOpenedSetTy } from '../../baseComponents/Modal/types'
import { BeforeSubmitHandler, OnSubmit } from '../../forms/TwinForm/types'

export interface ModalFormValidationProps {
    setOpened: ModalOpenedSetTy
    onSubmit: OnSubmit
    endLoading?: () => void 
    beforeSubmit?: BeforeSubmitHandler
    triggerOpen?: boolean
}

const useModalFormValidation = ({setOpened, onSubmit, endLoading, beforeSubmit, triggerOpen = true}: ModalFormValidationProps) => {
    const handleOnSubmit: OnSubmit = useCallback((res, valuesSend) => {
        endLoading?.()
        if (triggerOpen) {
            setOpened(null)
        }
        onSubmit?.(res, valuesSend)
    }, [setOpened, onSubmit, endLoading, triggerOpen])

    const handleOnPreSubmit: BeforeSubmitHandler = useCallback((values, form) => {
        if (beforeSubmit && !beforeSubmit(values, form)) {
            endLoading?.()
            return false
        } 
        return true
    }, [beforeSubmit, endLoading])

    return { handleOnSubmit, handleOnPreSubmit }

}


export default useModalFormValidation